module.exports = __webpack_public_path__ + "img/excedrin_migraine_relief_caplets.82156bef.jpg";